import { useNavigate } from 'react-router-dom';
import './style.css';

export function AboutUs({ image, title, description, linkText, route }) {
  const navigate = useNavigate();

    const handleClick = () => {
    if (route.startsWith('http://') || route.startsWith('https://')) {
      window.open(route, '_blank', 'noopener,noreferrer')
    } else {
      navigate(route)
    }
  }
  return (
    <div className="about-us-card">
      <div className="about-us-image">
        <img src={image} alt={title || 'Sobre Nós'} />
      </div>
      <div className="about-us-content">
        <h2 className="about-us-title">{title}</h2>
        <p className="about-us-description">{description}</p>
        <h4 className="about-us-link" onClick={handleClick}>{linkText}</h4>
      </div>
    </div>
  )
}
